<template>
  <el-form ref="form" :model="form" label-width="100px" class="cash">
    <section class="content-left">
      <el-form-item class="decrease-time" label="减免金额">
        <el-input v-model="form.amount"></el-input>
        <div class="minutes-text">(元)</div>
      </el-form-item>
      <section class="use-time">
        <el-form-item label="使用时段">
          <el-select v-model="form.usagePeriod.type" placeholder="请选择使用时段">
            <el-option v-for="{ label, value } in USE_TIME_TYPE" :key="value" :value="value" :label="label"></el-option>
          </el-select>
          <div class="time-range">
            <el-time-picker v-model="form.usagePeriod.fromTime" value-format="HH:mm" format="HH:mm" placeholder="选择时间">
            </el-time-picker>
            <span>至</span>
            <el-time-picker v-model="form.usagePeriod.toTime" value-format="HH:mm" format="HH:mm" placeholder="选择时间">
            </el-time-picker>
          </div>
        </el-form-item>
      </section>
      <section class="use-restrict">
        <el-form-item label="使用限制">
          <el-checkbox v-model="form.usageLimit.chargeDeviceAutoUse">收费客户端不自动使用</el-checkbox>
          <el-checkbox v-model="form.usageLimit.currParkUse"> 限本次停车使用</el-checkbox>
        </el-form-item>
      </section>
      <section class="coupon-validity">
        <el-form-item label="用券有效期">
          <el-select v-model="form.validPeriodForUse.type" placeholder="请选择用券有效期" :disabled="type==='edit'">
            <el-option v-for="{ label, value } in VALID_PERIOD_TYPE" :key="value" :value="value" :label="label" ></el-option>
          </el-select>
          <div class="minutes">
            <el-input v-model="form.validPeriodForUse.validMins" :disabled="type==='edit'"></el-input>
            <div class="minutes-text">(分钟)</div>
          </div>
        </el-form-item>
      </section>
      <section class="release-quantity">
        <el-form-item label="每人限领">
          <div class="quantity">
            <el-input v-model="form.ticketNumPerPerson"></el-input>
            <div class="minutes-text">(张)</div>
          </div>
          <!-- <el-checkbox v-model="checked">叠加限制</el-checkbox> -->
        </el-form-item>
      </section>
    </section>
    <section class="content-right">
      <el-form-item class="fee-to" label="停车费满">
        <el-input v-model="form.validPeriodForUse.stopMeetFees"></el-input>
        <div class="minutes-text">(元)可使用</div>
      </el-form-item>

      <section class="release-quantity">
        <el-form-item label="最多使用">
          <div class="quantity">
            <el-input v-model="form.maxUseNum"></el-input>
            <div class="minutes-text">(张)</div>
          </div>

        </el-form-item>
      </section>



      <section class="trading-mode">
        <el-form-item label="交易方式">
          <el-select v-model="form.tranMode" placeholder="请选择交易方式">
            <el-option v-for="{ label, value } in TRADE_MODE" :key="label" :value="value" :label="label"></el-option>

          </el-select>
        </el-form-item>
      </section>

      <section class="issue-coupon-validity">
        <el-form-item label="发券有效期">
          <el-select v-model="form.validPeriodForIssue.type" placeholder="请选择发券有效期"  :disabled="type==='edit'">
            <el-option v-for="{ label, value } in VALID_PERIOD_TYPE" :key="label" :value="value" :label="label"  ></el-option>

          </el-select>
          <div class="minutes">
            <el-input v-model="form.validPeriodForIssue.validMins" :disabled="type==='edit'"></el-input>
            <div class="minutes-text">(分钟)</div>
          </div>
        </el-form-item>
      </section>

      <section class="unit-price">
        <el-form-item label="单价">
          <el-input v-model="form.unitPrice"></el-input>
        </el-form-item>
      </section>
    </section>
  </el-form>
</template>
<script>
import { USE_TIME_TYPE, DEDUCTION_MODE, VALID_PERIOD_TYPE, TRADE_MODE } from "../../constant.js"
export default {
  name: "cash", //代金券
  props:{coupon:String,type:String},
  data() {
    return {
      form: {},
      USE_TIME_TYPE,
      DEDUCTION_MODE,
      VALID_PERIOD_TYPE,
      TRADE_MODE
    };
  },
  computed: {
    couponEditData: function() {

      return JSON.parse(this.coupon);
    },
  },
  watch: {
    couponEditData: {
      handler: function(newVal, oldVal) {

        newVal?this.form = JSON.parse(JSON.stringify(newVal)):this.form=this.initForm()
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    getData() {
      return this.form;
    },
    initForm() {
      return {
        amount: 0,
        usagePeriod: {
          //使用时段
          fromTime: "00:00",
          toTime: "23:59",
          type: "all",
        },
        usageLimit: {
          //使用限制
          chargeDeviceAutoUse: false, //收费客户端不自动使用
          currParkUse: true, //限本次停车使用
        },
        validPeriodForUse: {
          //用券有效期
          stopMeetFees: 120.0, //停车费满
          type: "CurrentTimeStart",

          validMins: 60,
        },
        maxUseNum: 1000, //券最多使用张数,  -1 表示不限数量


        tranMode: "AccountDeduction", //交易方式

        validPeriodForIssue: {
          //发券有效期
          type: "CurrentTimeStart", //参考 validPeriodForUse.type
          validMins: 60,
        },
        unitPrice: 2.0, //单价
        ticketNumPerPerson: 1//没人最多可领
      }
    }
  },
};
</script>
<style lang="scss">
.cash {
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;

  .content-left {
    width: 49%;
  }

  .content-right {
    width: 49%;
  }
}

.decrease-time .el-form-item__content {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.decrease-time .el-form-item__content .el-input__inner {
  width: calc(100% - 50px);
}

.minutes-text {
  width: 50px;
}

.use-time {
  .el-select {
    margin-right: 20px;
  }

  .el-form-item__content {
    display: flex;
    justify-content: flex-start;

    .el-select {
      width: 40%;
    }

    .time-range {
      width: 60%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
}

.use-restrict {
  .el-form-item {
    display: flex;

    align-items: center;
  }

  .el-form-item__content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 0 !important;
  }
}

.coupon-validity {
  .el-form-item__content {
    display: flex;
    justify-content: flex-start;

    .el-select {
      width: 50%;
      margin-right: 20px;
    }

    .minutes {
      width: 50%;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .el-input {
        width: calc(100% - 60px);
        margin-right: 10px;
      }

      .minutes-text {
        width: 60px;
      }
    }
  }
}

.fee-to {
  .el-form-item__content {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .el-input {
      width: calc(100% - 100px);
      margin-right: 10px;
    }

    .minutes-text {
      width: 100px;
    }
  }
}

.time-deduction-method {
  .el-select {
    width: 100%;
  }
}

.restrict-use-condition {
  .el-select {
    width: 100%;
  }
}

.is-disposition-date {
  .el-form-item {
    display: flex;
    justify-content: flex-start;

    .el-form-item__label {
      width: auto !important;
    }

    .el-form-item__content {
      margin-left: 0 !important;
    }
  }
}

.select-park {
  .el-form-item__content {
    display: flex;
    justify-content: flex-start;

    .el-textarea {
      margin-right: 20px;
    }
  }
}

.release-quantity {
  .quantity {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .el-form-item__content {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}

.trading-mode {
  .el-select {
    width: 100%;
  }
}

.issue-coupon-validity {
  .el-form-item__content {
    display: flex;
    justify-content: flex-start;

    .el-select {
      width: 50%;
      margin-right: 20px;
    }

    .minutes {
      width: 50%;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .el-input {
        width: calc(100% - 60px);
        margin-right: 10px;
      }

      .minutes-text {
        width: 60px;
      }
    }
  }
}</style>
